module.exports = __webpack_public_path__ + "static/img/icon-radio.bf182f7e.svg";